var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "project-page" },
    [
      _c("div", { staticClass: "row mt-3" }, [
        _c("div", { staticClass: "col-6" }, [
          _vm.isExist(_vm.navigations.prev)
            ? _c(
                "a",
                {
                  staticClass: "button type-13 type-13-lc toLeft",
                  attrs: { href: _vm.navigations.prev, title: "" }
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_back")
                  ]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.trans("lifechallenge_previous")) +
                      "\n      "
                  )
                ]
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "col-6" }, [
          _vm.isExist(_vm.navigations.next)
            ? _c(
                "a",
                {
                  staticClass: "button type-14 toRight",
                  attrs: {
                    href: _vm.navigations.next,
                    title: "",
                    id: "next_project_button"
                  }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.trans("lifechallenge_next")) +
                      "\n        "
                  ),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("arrow_forward")
                  ])
                ]
              )
            : _vm._e()
        ])
      ]),
      _c("project-galleries", {
        attrs: {
          images: _vm.sortImages(_vm.project.images),
          projectData: _vm.project,
          "voting-enabled": _vm.voting_enabled
        }
      }),
      _c("div", { staticClass: "row mt-4 full-width" }, [
        _c(
          "div",
          { staticClass: "col-md-8 col-12 mt-1 order-md-1 order-2 white-bg" },
          [
            _vm.isExist(_vm.project.description2)
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: { innerHTML: _vm._s(_vm.project.description2) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.project.insulation_eps ||
            _vm.project.insulation_mineral ||
            _vm.project.insulation_open ||
            _vm.project.insulation_pro ||
            _vm.project.insulation_star ||
            _vm.project.insulation_ceramic_lc
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("lifechallenge_baumit_insulation_system")
                        )
                      )
                    ]),
                    _c("div", { staticClass: "list-of-links ml-2 mt-3" }, [
                      _c("ul", [
                        _vm.project.insulation_eps
                          ? _c("li", [
                              _c("p", { staticClass: "link" }, [
                                _c("span", {
                                  staticClass: "mdi mdi-chevron-right"
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.trans("lifechallenge_baumit_eps")
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm.project.insulation_mineral &&
                        !_vm.project.insulation_open &&
                        !_vm.project.insulation_star &&
                        !_vm.project.insulation_pro
                          ? _c("li", [
                              _c("p", { staticClass: "link" }, [
                                _c("span", {
                                  staticClass: "mdi mdi-chevron-right"
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.trans("lifechallenge_baumit_mineral")
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm.project.insulation_open
                          ? _c("li", [
                              _vm.project.insulation_mineral
                                ? _c("p", { staticClass: "link" }, [
                                    _c("span", {
                                      staticClass: "mdi mdi-chevron-right"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.trans(
                                            "lifechallenge_baumit_open_mineral"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("p", { staticClass: "link" }, [
                                    _c("span", {
                                      staticClass: "mdi mdi-chevron-right"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.trans("lifechallenge_baumit_open")
                                        ) +
                                        "\n                "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm.project.insulation_pro
                          ? _c("li", [
                              _vm.project.insulation_mineral
                                ? _c("p", { staticClass: "link" }, [
                                    _c("span", {
                                      staticClass: "mdi mdi-chevron-right"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.trans(
                                            "lifechallenge_baumit_pro_mineral"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("p", { staticClass: "link" }, [
                                    _c("span", {
                                      staticClass: "mdi mdi-chevron-right"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.trans("lifechallenge_baumit_pro")
                                        ) +
                                        "\n                "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm.project.insulation_star
                          ? _c("li", [
                              _vm.project.insulation_mineral
                                ? _c("p", { staticClass: "link" }, [
                                    _c("span", {
                                      staticClass: "mdi mdi-chevron-right"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.trans(
                                            "lifechallenge_baumit_star_mineral"
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("p", { staticClass: "link" }, [
                                    _c("span", {
                                      staticClass: "mdi mdi-chevron-right"
                                    }),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.trans("lifechallenge_baumit_star")
                                        ) +
                                        "\n                "
                                    )
                                  ])
                            ])
                          : _vm._e(),
                        _vm.project.insulation_ceramic_lc
                          ? _c("li", [
                              _c("p", { staticClass: "link" }, [
                                _c("span", {
                                  staticClass: "mdi mdi-chevron-right"
                                }),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.trans("lifechallenge_baumit_ceramic")
                                    ) +
                                    "\n                "
                                )
                              ])
                            ])
                          : _vm._e()
                      ])
                    ])
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.products) && _vm.project.products.length > 0
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.trans("lifechallenge_baumit_materials"))
                      )
                    ]),
                    _c(
                      "div",
                      {
                        staticClass:
                          "list-of-links ml-2 mt-3 lc-product-materiels"
                      },
                      [
                        _c(
                          "ul",
                          _vm._l(_vm.project.products, function(
                            product,
                            index
                          ) {
                            return _c(
                              "li",
                              { key: "product_" + index },
                              [
                                typeof product.details_url_with_domain !=
                                  "undefined" &&
                                product.details_url_with_domain.length > 0
                                  ? [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            target: "_blank",
                                            href:
                                              product.details_url_with_domain,
                                            title: ""
                                          }
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "mdi mdi-chevron-right"
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(product.epim_name) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                                  : [
                                      _c(
                                        "span",
                                        { staticClass: "base-prod-nonelink" },
                                        [
                                          _c("span", {
                                            staticClass: "mdi mdi-chevron-right"
                                          }),
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(product.epim_name) +
                                              "\n                  "
                                          )
                                        ]
                                      )
                                    ]
                              ],
                              2
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.color_tone1) ||
            _vm.isExist(_vm.project.color_tone2) ||
            _vm.isExist(_vm.project.color_tone3)
              ? _c("div", { staticClass: "row lc-colortone-cards mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", { staticClass: "mb-3" }, [
                      _vm._v(
                        _vm._s(_vm.trans("lifechallenge_baumit_life_color"))
                      )
                    ])
                  ]),
                  _vm.isExist(_vm.project.color_tone1) &&
                  _vm.isExist(_vm.project.color_tone1.name)
                    ? _c(
                        "div",
                        { staticClass: "col  lc-colortone-card-item mb-5" },
                        [
                          _c("color-tone-card", {
                            attrs: { color_tone: _vm.project.color_tone1 }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isExist(_vm.project.color_tone2) &&
                  _vm.isExist(_vm.project.color_tone2.name)
                    ? _c(
                        "div",
                        { staticClass: "col  lc-colortone-card-item mb-5" },
                        [
                          _c("color-tone-card", {
                            attrs: { color_tone: _vm.project.color_tone2 }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.isExist(_vm.project.color_tone3) &&
                  _vm.isExist(_vm.project.color_tone3.name)
                    ? _c(
                        "div",
                        { staticClass: "col  lc-colortone-card-item mb-5" },
                        [
                          _c("color-tone-card", {
                            attrs: { color_tone: _vm.project.color_tone3 }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.other_baumit_products)
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(
                          _vm.trans("lifechallenge_further_baumit_products")
                        )
                      )
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: {
                        innerHTML: _vm._s(_vm.project.other_baumit_products)
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.description3)
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(
                        _vm._s(_vm.trans("description_further_information"))
                      )
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: { innerHTML: _vm._s(_vm.project.description3) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.youtube_video_id) &&
            _vm.project.youtube_video_id != ""
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.trans("lc_video")))]),
                    _c("div", {
                      staticClass: "youtube-player-container youtube-player",
                      attrs: {
                        "data-id":
                          "https://www.youtube.com/embed/" +
                          _vm.project.youtube_video_id +
                          "?rel=0",
                        "data-quality": "maxres",
                        "data-version": "2"
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.attachments) &&
            _vm.project.attachments.length > 0
              ? _c("div", { staticClass: "row mt-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_attachments")))
                    ])
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.attachments) &&
            _vm.project.attachments.length > 0
              ? _c("div", { staticClass: "row mt-3" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    _vm._l(_vm.project.attachments, function(
                      attachment,
                      index
                    ) {
                      return attachment.status
                        ? _c("div", { staticClass: "attachment-bg" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: attachment.source,
                                  target: "_blank"
                                }
                              },
                              [
                                _c("span", { staticClass: "mdi mdi-download" }),
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getAttachmentName(attachment.source)
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]
        ),
        _c(
          "div",
          { staticClass: "col-md-4 col-12 mt-2 order-md-2 order-1 lc-slider" },
          [
            (_vm.isExist(_vm.project.color_tone1) ||
              _vm.isExist(_vm.project.color_tone2) ||
              _vm.isExist(_vm.project.color_tone3)) &&
            false
              ? _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", { staticClass: "mb-3" }, [
                      _vm._v(
                        _vm._s(_vm.trans("lifechallenge_baumit_life_color"))
                      )
                    ]),
                    _vm.isExist(_vm.project.color_tone1) &&
                    _vm.isExist(_vm.project.color_tone1.name) &&
                    _vm.isExist(_vm.project.color_tone1.hex)
                      ? _c("div", { staticClass: "lc-color-block mb-2" }, [
                          _c("div", { staticClass: "lc-color-title" }, [
                            _c("p", { staticClass: "bodytext" }, [
                              _vm._v(_vm._s(_vm.project.color_tone1.name))
                            ])
                          ]),
                          _c("div", {
                            staticClass: "lc-color",
                            style: {
                              "background-color":
                                "#" + _vm.project.color_tone1.hex
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm.isExist(_vm.project.color_tone2) &&
                    _vm.isExist(_vm.project.color_tone2.name) &&
                    _vm.isExist(_vm.project.color_tone2.hex)
                      ? _c("div", { staticClass: "lc-color-block mb-2" }, [
                          _c("div", { staticClass: "lc-color-title" }, [
                            _c("p", { staticClass: "bodytext" }, [
                              _vm._v(_vm._s(_vm.project.color_tone2.name))
                            ])
                          ]),
                          _c("div", {
                            staticClass: "lc-color",
                            style: {
                              "background-color":
                                "#" + _vm.project.color_tone2.hex
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm.isExist(_vm.project.color_tone3) &&
                    _vm.isExist(_vm.project.color_tone3.name) &&
                    _vm.isExist(_vm.project.color_tone3.hex)
                      ? _c("div", { staticClass: "lc-color-block mb-2" }, [
                          _c("div", { staticClass: "lc-color-title" }, [
                            _c("p", { staticClass: "bodytext" }, [
                              _vm._v(_vm._s(_vm.project.color_tone3.name))
                            ])
                          ]),
                          _c("div", {
                            staticClass: "lc-color",
                            style: {
                              "background-color":
                                "#" + _vm.project.color_tone3.hex
                            }
                          })
                        ])
                      : _vm._e()
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.architect)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_architect_pp")))
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: { innerHTML: _vm._s(_vm.project.architect) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.applicator)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_applicator")))
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: { innerHTML: _vm._s(_vm.project.applicator) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.construction_management)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_constructor")))
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: {
                        innerHTML: _vm._s(_vm.project.construction_management)
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.investor)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_investor_pp")))
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: { innerHTML: _vm._s(_vm.project.investor) }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.life_challenge_city)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_location")))
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: {
                        innerHTML: _vm._s(_vm.project.life_challenge_city)
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.year_of_finishing_work)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.trans("lifechallenge_year")))]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: {
                        innerHTML: _vm._s(_vm.project.year_of_finishing_work)
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm.isExist(_vm.project.life_challenge_category)
              ? _c("div", { staticClass: "row mt-2" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h3", [
                      _vm._v(_vm._s(_vm.trans("lifechallenge_category")))
                    ]),
                    _c("p", {
                      staticClass: "bodytext",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getCategory(_vm.project.life_challenge_category)
                        )
                      }
                    })
                  ])
                ])
              : _vm._e()
          ]
        )
      ]),
      _vm.voting_enabled
        ? _c("div", { staticClass: "vote" }, [
            _c(
              "div",
              { staticClass: "vote-content" },
              [
                _vm.voting_enabled
                  ? _c("Vote", {
                      attrs: {
                        id: _vm.project.id,
                        isCompact: false,
                        year: _vm.year
                      },
                      on: { voted: _vm.onVoted }
                    })
                  : _vm._e()
              ],
              1
            )
          ])
        : _vm._e(),
      _vm.width <= 959
        ? _c("div", { staticClass: "row mt-3" }, [
            _c("div", { staticClass: "col-6" }, [
              _vm.isExist(_vm.navigations.prev)
                ? _c(
                    "a",
                    {
                      staticClass: "button type-13 type-13-lc toLeft",
                      attrs: { href: _vm.navigations.prev, title: "" }
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("arrow_back")
                      ]),
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.trans("lifechallenge_previous")) +
                          "\n      "
                      )
                    ]
                  )
                : _vm._e()
            ]),
            _c("div", { staticClass: "col-6" }, [
              _vm.isExist(_vm.navigations.next)
                ? _c(
                    "a",
                    {
                      staticClass: "button type-14 toRight",
                      attrs: { href: _vm.navigations.next, title: "" }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.trans("lifechallenge_next")) +
                          "\n        "
                      ),
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("arrow_forward")
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ])
        : _vm._e(),
      _vm.juryModalVisible
        ? _c("jury-modal-change-category", {
            attrs: {
              year: _vm.year,
              juryModalVisible: _vm.juryModalVisible,
              lifeChallengeCategory: _vm.project.life_challenge_category
            },
            on: { settingJuryModalVisible: _vm.onSettingJuryModalVisible }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }